import { Box, BoxProps } from '@clear/design-system'
import React from 'react'

type DividerProps = Partial<BoxProps>

const Divider = ({ mt = 6, mb = 6, ...props }: DividerProps) => (
  <Box
    width="100%"
    sx={{ outline: '1px #D9D9D9 solid' }}
    mt={mt}
    mb={mb}
    {...props}
  />
)

export default Divider
